module.exports = __webpack_public_path__ + "static/media/iphone_se_product_red.40218924.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/iphone_se_product_red.png
// module id = 2080
// module chunks = 0